import React, { FC } from 'react';
import styles from './index.module.scss';
import { Alert, Skeleton } from 'src/common';
import { useTranslation } from 'react-i18next';
import { AggregateBy } from '../Sidebar/AggregateSelect/types';
import { IHandledDocument, ISearchProfile } from '../types';
import SearchResultsByProfiles from './SearchResultsByProfiles';
import SearchResultsByDocuments from './SearchResultsByDocuments';

export interface IContentProps {
  loading: boolean;
  error?: Error;
  documents: IHandledDocument[];
  searchProfiles: ISearchProfile[];
  aggregateBy: AggregateBy;
  totalTermsCount: number;
  filteredTermsCount: number;
}

export const Content: FC<IContentProps> = props => {
  const { error, loading, documents, searchProfiles, aggregateBy, totalTermsCount, filteredTermsCount } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {loading ? (
        <Skeleton active={true} loading={true} />
      ) : error ? (
        <Alert type={'error'} message={t(String(error))} />
      ) : (
        <>
          <div className={styles.stats}>
            {`${t('KeywordSearch.totalHits')}: ${totalTermsCount}`}
            {` (${t('KeywordSearch.showing')} ${filteredTermsCount})`}
          </div>
          {!!documents.length ? (
            aggregateBy === AggregateBy.SearchProfile ? (
              <SearchResultsByProfiles documents={documents} searchProfiles={searchProfiles} />
            ) : (
              <SearchResultsByDocuments documents={documents} />
            )
          ) : (
            <span className={styles.emptyMessage}>
              {t(
                aggregateBy === AggregateBy.SearchProfile
                  ? 'KeywordSearch.emptyResultOfSearch'
                  : 'KeywordSearch.noDocumentsAvailableToScan'
              )}
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default Content;
